var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/hospital") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/hospital",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,2 L15,2 L15,9 L18,9 L18,18 L2,18 L2,9 L5,9 L5,2 L13.99925,2 L13.99925,9 L14,9 L14,2 Z",
    id: "Combined-Shape",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14 L6,16 L4,16 L4,14 L6,14 Z M16,14 L16,16 L14,16 L14,14 L16,14 Z M11,14 L11,16 L9,16 L9,14 L11,14 Z M7,7 L7,5 L9,5 L9,3 L11,3 L11,5 L13,5 L13,7 L11,7 L11,9 L9,9 L9,7 L7,7 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.8b9d317ff6e2fd7f2151864448b0ce69.svg";
export { ForwardRef as ReactComponent };